import { axiosMailSenderAPI } from './api';
import { recipientsMailSenderAPI } from './constants';

import Vue from 'vue';
import Vuex from 'vuex';


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
  },
  getters: {
    isLoading: (state) => state.isLoading,
  },
  mutations: {
    loading(state) {
      state.isLoading = true;
    },
    loaded(state) {
      state.isLoading = false;
    },
  },
  actions: {
    // Отправить отзыв
    sendFeedback({commit}, data) {
      commit('loading');
      return new Promise((resolve, reject) => {

        let url = '/external-mailing';
        let payloadBodyFormData = new FormData();
        payloadBodyFormData.set('from_name', 'job.rris.ru landing');
        payloadBodyFormData.set('subject', 'Заявка с сайта job.rris.ru');

        let htmlBody = `<h1>Заявка с сайта job.rris.ru</h1><br>`;
        htmlBody += `Имя и фамилия: ${data.name}<br>`;
        htmlBody += `Телефон: ${data.phone}<br>`;
        htmlBody += `Почта: ${data.email}<br>`;
        htmlBody += `Возраст: ${data.age}<br>`;
        htmlBody += `Гражданство: ${data.citizenship}<br>`;
        payloadBodyFormData.set('html_body', htmlBody);

        // Крепим почты на которые отправлять (получили от backend)
        for (let i=0; i < recipientsMailSenderAPI.length; i++) {
          const itemEmail = recipientsMailSenderAPI[i];
          payloadBodyFormData.set(`recipients[${i}]`, itemEmail);
        }

        axiosMailSenderAPI({
          method: 'post',
          url: url,
          data: payloadBodyFormData,
          config: {
            headers: {'Content-Type': 'multipart/form-data' }
          },
        })
          .then(resp => {
            commit('loaded');
            resolve(resp);
          })
          .catch(err => {
            commit('loaded');
            reject(err);
          })
      })
    },
  },
});
